/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Domestic_LabelInputs */

const en_shipping_domestic_label = /** @type {(inputs: Shipping_Domestic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domestic Shipping Fee`)
};

const es_shipping_domestic_label = /** @type {(inputs: Shipping_Domestic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifa de Envío Nacional`)
};

const fr_shipping_domestic_label = /** @type {(inputs: Shipping_Domestic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frais de port nationaux`)
};

const de_shipping_domestic_label = /** @type {(inputs: Shipping_Domestic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inländische Versandkosten`)
};

const id_shipping_domestic_label = /** @type {(inputs: Shipping_Domestic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya Pengiriman Domestik`)
};

/** @type {(inputs: Shipping_Domestic_LabelInputs) => LocalizedString} */
const ja_shipping_domestic_label = en_shipping_domestic_label;

/** @type {(inputs: Shipping_Domestic_LabelInputs) => LocalizedString} */
const zh_shipping_domestic_label = en_shipping_domestic_label;

/** @type {(inputs: Shipping_Domestic_LabelInputs) => LocalizedString} */
const ar_shipping_domestic_label = en_shipping_domestic_label;

/** @type {(inputs: Shipping_Domestic_LabelInputs) => LocalizedString} */
const it_shipping_domestic_label = en_shipping_domestic_label;

/** @type {(inputs: Shipping_Domestic_LabelInputs) => LocalizedString} */
const ru_shipping_domestic_label = en_shipping_domestic_label;

/** @type {(inputs: Shipping_Domestic_LabelInputs) => LocalizedString} */
const pt_shipping_domestic_label = en_shipping_domestic_label;

/** @type {(inputs: Shipping_Domestic_LabelInputs) => LocalizedString} */
const ko_shipping_domestic_label = en_shipping_domestic_label;

/**
* | output |
* | --- |
* | "Domestic Shipping Fee" |
*
* @param {Shipping_Domestic_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shipping_domestic_label = /** @type {((inputs?: Shipping_Domestic_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Domestic_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_domestic_label(inputs)
	if (locale === "es") return es_shipping_domestic_label(inputs)
	if (locale === "fr") return fr_shipping_domestic_label(inputs)
	if (locale === "de") return de_shipping_domestic_label(inputs)
	if (locale === "ja") return ja_shipping_domestic_label(inputs)
	if (locale === "zh") return zh_shipping_domestic_label(inputs)
	if (locale === "ar") return ar_shipping_domestic_label(inputs)
	if (locale === "id") return id_shipping_domestic_label(inputs)
	if (locale === "it") return it_shipping_domestic_label(inputs)
	if (locale === "ru") return ru_shipping_domestic_label(inputs)
	if (locale === "pt") return pt_shipping_domestic_label(inputs)
	return ko_shipping_domestic_label(inputs)
});